/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */

export * from './AffiliateApi';
import { AffiliateApi } from './AffiliateApi';
export * from './FollowApi';
import { FollowApi } from './FollowApi';
export * from './CommunicationPrefsApi';
import { CommunicationPrefsApi } from './CommunicationPrefsApi';
export * from './UsersApi';
import { UsersApi } from './UsersApi';
export * from './BugsApi';
import { BugsApi } from './BugsApi';
export * from './LiveStreamsApi';
import { LiveStreamsApi } from './LiveStreamsApi';
export * from './MembershipApi';
import { MembershipApi } from './MembershipApi';
export * from './MembershipProductsApi';
import { MembershipProductsApi } from './MembershipProductsApi';
export * from './OffersApi';
import { OffersApi } from './OffersApi';
export * from './OfferSetsApi';
import { OfferSetsApi } from './OfferSetsApi';
export * from './LogsApi';
import { LogsApi } from './LogsApi';
export * from './LegacyApi';
import { LegacyApi } from './LegacyApi';
export * from './GiftsApi';
import { GiftsApi } from './GiftsApi';
export * from './SponsorshipProductsApi';
import { SponsorshipProductsApi } from './SponsorshipProductsApi';
export * from './GuestsApi';
import { GuestsApi } from './GuestsApi';
export * from './PollsApi';
import { PollsApi } from './PollsApi';
export * from './ActblueApi';
import { ActblueApi } from './ActblueApi';
export * from './ExternalApi';
import { ExternalApi } from './ExternalApi';
export * from './ContributionsApi';
import { ContributionsApi } from './ContributionsApi';
export * from './CountriesApi';
import { CountriesApi } from './CountriesApi';
export * from './ImpactsApi';
import { ImpactsApi } from './ImpactsApi';
export * from './ModerationApi';
import { ModerationApi } from './ModerationApi';
export * from './TopicApi';
import { TopicApi } from './TopicApi';
export * from './PlaybackApi';
import { PlaybackApi } from './PlaybackApi';
export * from './PagesApi';
import { PagesApi } from './PagesApi';
export * from './PressArticlesApi';
import { PressArticlesApi } from './PressArticlesApi';
export * from './CareersApi';
import { CareersApi } from './CareersApi';
export * from './CarouselSlidesApi';
import { CarouselSlidesApi } from './CarouselSlidesApi';
export * from './AnnouncementsApi';
import { AnnouncementsApi } from './AnnouncementsApi';
export * from './AffiliateMarketingApi';
import { AffiliateMarketingApi } from './AffiliateMarketingApi';
export * from './ArticlesApi';
import { ArticlesApi } from './ArticlesApi';
export * from './FranchiseApi';
import { FranchiseApi } from './FranchiseApi';
export * from './LiveScheduleListsApi';
import { LiveScheduleListsApi } from './LiveScheduleListsApi';
export * from './ProductionsApi';
import { ProductionsApi } from './ProductionsApi';
export * from './TalentApi';
import { TalentApi } from './TalentApi';
export * from './ShowsApi';
import { ShowsApi } from './ShowsApi';
export * from './AppApi';
import { AppApi } from './AppApi';
export const APIS = [AffiliateApi, FollowApi, CommunicationPrefsApi, UsersApi, BugsApi, LiveStreamsApi, MembershipApi, MembershipProductsApi, OffersApi, OfferSetsApi, LogsApi, LegacyApi, GiftsApi, SponsorshipProductsApi, GuestsApi, PollsApi, ActblueApi, ExternalApi, ContributionsApi, CountriesApi, ImpactsApi, ModerationApi, TopicApi, PlaybackApi, PagesApi, PressArticlesApi, CareersApi, CarouselSlidesApi, AnnouncementsApi, AffiliateMarketingApi, ArticlesApi, FranchiseApi, LiveScheduleListsApi, ProductionsApi, TalentApi, ShowsApi, AppApi, ];
